import * as ambassadorWixEcomApiV1CheckoutContentProvider from './ecom-api-v1-checkout-content-provider-checkout-content.http.js';
import * as ambassadorWixEcomApiV1CheckoutContentProviderTypes from './ecom-api-v1-checkout-content-provider-checkout-content.types.js';
import * as ambassadorWixEcomApiV1CheckoutContentProviderUniversalTypes from './ecom-api-v1-checkout-content-provider-checkout-content.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function getCheckoutContent(): __PublicMethodMetaInfo<
  'GET',
  { appId: string; componentId: string },
  ambassadorWixEcomApiV1CheckoutContentProviderUniversalTypes.GetCheckoutContentRequest,
  ambassadorWixEcomApiV1CheckoutContentProviderTypes.GetCheckoutContentRequest,
  ambassadorWixEcomApiV1CheckoutContentProviderUniversalTypes.GetCheckoutContentResponse,
  ambassadorWixEcomApiV1CheckoutContentProviderTypes.GetCheckoutContentResponse
> {
  const payload = { appId: ':appId', componentId: ':componentId' } as any;

  const getRequestOptions =
    ambassadorWixEcomApiV1CheckoutContentProvider.getCheckoutContent(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/checkout-content/{appId}/{componentId}',
    pathParams: { appId: 'appId', componentId: 'componentId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  CheckoutContentProvider as CheckoutContentProviderOriginal,
  GetCheckoutContentRequest as GetCheckoutContentRequestOriginal,
  GetCheckoutContentResponse as GetCheckoutContentResponseOriginal,
  CheckoutContent as CheckoutContentOriginal,
  GetCheckoutContentApplicationErrors as GetCheckoutContentApplicationErrorsOriginal,
} from './ecom-api-v1-checkout-content-provider-checkout-content.types.js';
